<div class="main-container">
  <form [formGroup]="ticketDashboardSearchForm" novalidate>
    <!-- Header Section -->
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title">Ticket Dashboard</span>
      </div>
    </div>

    <!-- KPI Section -->
    <div class="kpi-section">
      <!-- All Tickets -->
      <div
        class="kpi-card kpi-gradient-blue"
        (click)="fetchData('ALL')"
        tabindex="0"
        (keydown.enter)="fetchData('ALL')"
      >
        <div class="kpi-details">
          <span class="kpi-content"
            >ALL
            <app-info-tooltip
              block
              heading="ALL"
              [description]="kpiInfo.all"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">
            {{ (allCount ? allCount : 0) | indianNumber }}</span
          >
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/all-tasks.png"
            alt="ALL Image"
          />
        </div>
      </div>

      <!-- IN PROGRESS Tickets-->
      <div
        class="kpi-card kpi-gradient-orange"
        (click)="fetchData('PRO')"
        tabindex="0"
        (keydown.enter)="fetchData('PRO')"
      >
        <div class="kpi-details">
          <span class="kpi-content"
            >IN PROGRESS
            <app-info-tooltip
              block
              heading="IN PROGRESS"
              [description]="kpiInfo.inProgress"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">{{
            (inProgress ? inProgress : 0) | indianNumber
          }}</span>
        </div>
        <div class="kpi-visual">
          <img
            src="../../assets/in-progress-task.png"
            alt="IN PROGRESS Image"
          />
        </div>
      </div>
      <!--On Hold Tickets-->
      <div
        class="kpi-card kpi-gradient-yellow"
        (click)="fetchData('HOLD')"
        tabindex="0"
        (keydown.enter)="fetchData('HOLD')"
      >
        <div class="kpi-details">
          <span class="kpi-content"
            >ON HOLD
            <app-info-tooltip
              block
              heading="ON HOLD"
              [description]="kpiInfo.onHold"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">
            {{ (onHold ? onHold : 0) | indianNumber }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/onHold-task.png"
            alt="ON HOLD Image"
          />
        </div>
      </div>
      <!-- CANCELLED Tickets-->
      <div
        class="kpi-card kpi-gradient-pink"
        (click)="fetchData('CAN')"
        tabindex="0"
        (keydown.enter)="fetchData('CAN')"
      >
        <div class="kpi-details">
          <span class="kpi-content"
            >CANCELLED
            <app-info-tooltip
              block
              heading="CANCELLED"
              [description]="kpiInfo.cancelled"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">
            {{ (cancelled ? cancelled : 0) | indianNumber }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/cancelled-task.png"
            alt="CANCELLED Image"
          />
        </div>
      </div>

      <!-- Completed Tickets -->
      <div
        class="kpi-card kpi-gradient-green"
        (click)="fetchData('COM')"
        tabindex="0"
        (keydown.enter)="fetchData('COM')"
      >
        <div class="kpi-details">
          <span class="kpi-content"
            >COMPLETED
            <app-info-tooltip
              block
              heading="COMPLETED"
              [description]="kpiInfo.completed"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">
            {{ (completed ? completed : 0) | indianNumber }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/completed-task.png"
            alt="COMPLETED Image"
          />
        </div>
      </div>
    </div>

    <!-- Graph Section -->
    <div class="graph-section">
      <!-- Ticket Status Month Wise Ticket Trend Graph -->
      <div class="graph-card graph-card-wide">
        <div class="graph-body">
          <app-common-component-graph
            [title]="'Month-wise AIS140 Ticket Trend'"
            [infoDescription]="graphInfo.monthWise"
            [chartType]="'line'"
            [chartData]="monthWiseChartData"
            [chartOptions]="lineChartOptions"
            [xAxisLabel]="'Month'"
            [yAxisLabel]="'Ticket Count'"
          >
          </app-common-component-graph>
        </div>
      </div>
      <!-- AIS140 Ticket TAT Trend Graph -->
      <div class="graph-card graph-card-wide">
        <div class="graph-body">
          <app-common-component-graph
            [title]="'AIS140 Ticket TAT Trend'"
            [infoDescription]="graphInfo.tatBucket"
            [chartType]="'bar'"
            [chartData]="tatBucketChartData"
            [chartOptions]="barChartOptions"
            [legend]="false"
            [xAxisLabel]="'TAT buckets'"
            [yAxisLabel]="'Ticket Count'"
          >
          </app-common-component-graph>
        </div>
      </div>
      <!-- TAT Reason Breakdown (Tickets > 10 Hours) Graph -->
      <div class="graph-card graph-card-wide">
        <div class="graph-body">
          <app-common-component-graph
            [title]="'TAT Reason Breakdown (Tickets > 10 Hours)'"
            [infoDescription]="graphInfo.tatReasonBreakdown"
            [chartType]="'bar'"
            [chartData]="tatHoldReasonChartData"
            [chartOptions]="barChartOptions"
            [legend]="false"
            [xAxisLabel]="'TAT Reason'"
            [yAxisLabel]="'Ticket Count'"
          >
          </app-common-component-graph>
        </div>
      </div>
      <!-- State Wise Ticket Distribution Graph -->
      <div class="graph-card graph-card-wide">
        <div class="graph-body">
          <app-common-component-graph
            [title]="'State Wise Ticket Distribution'"
            [infoDescription]="graphInfo.stateWise"
            [chartType]="'bar'"
            [chartData]="stateChartData"
            [chartOptions]="barChartOptions"
            [stacked]="true"
            [xAxisLabel]="'State'"
            [yAxisLabel]="'Ticket Count'"
          >
          </app-common-component-graph>
        </div>
      </div>
      @if (MyActivationsViewMasterAccess) {
        <!-- Individual Performance Graph -->
        <div class="graph-card graph-card-wide">
          <div class="graph-body">
            <app-common-component-graph
              [title]="'Individual Performance'"
              [infoDescription]="graphInfo.individualPerformance"
              [chartType]="'bar'"
              [chartData]="userPerformanceChartData"
              [chartOptions]="barChartOptions"
              [stacked]="true"
              [xAxisLabel]="'Ticket Handler'"
              [yAxisLabel]="'Ticket Count'"
            >
            </app-common-component-graph>
          </div>
        </div>
      }
      <!-- Device Model Wise Graph -->
      <div class="graph-card graph-card-wide">
        <div class="graph-body">
          <app-common-component-graph
            [title]="'Device Model Wise Graph'"
            [infoDescription]="graphInfo.deviceModelWise"
            [chartType]="'pie'"
            [chartData]="deviceModelChartData"
            [chartOptions]="pieChartOptions"
          >
          </app-common-component-graph>
        </div>
      </div>
    </div>

    <!-- Ticket List -->
    <div class="component-container" #tableContainer>
      <!-- Component Header Section -->
      <div class="component-header">
        <h6 class="component-title">{{ table_title }} Tickets List</h6>
        <div class="component-actions">
          @if (ticketTATTimeReportView && projectName === 'TCU4G') {
            <button
              class="primary-button"
              [disabled]="totalLength === 0 || isDownloading"
              (click)="downloadTATReport()"
              type="button"
            >
              Download TAT Report<mat-icon class="btn-icon">download</mat-icon>
            </button>
          }
          <button
            class="primary-button"
            type="button"
            (click)="filterDropdownMenus()"
          >
            Filter<mat-icon class="btn-icon">filter_list</mat-icon>
          </button>

          <app-common-search
            [initialSearchValue]="
              ticketDashboardSearchForm?.get('ticketDashboardSearch')?.value
            "
            matTooltip="Ticket No | UIN NO. | Chassis NO. | IMEI NO. | ICCID NO. | Ticket Description"
            (searchSubmit)="onSearch($event)"
          ></app-common-search>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Ticket NO.</th>
              <th>UIN NO.</th>
              <th>Chassis NO.</th>
              <th>IMEI NO.</th>
              <th>RTO State</th>
              <th>Device Type</th>
              <th>Initiated By</th>
              <th>Ticket Handler</th>
              <th>Ticket Status</th>
              <th>Dealer</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Ticket Category</th>
            </tr>
          </thead>
          @if (totalLength !== 0) {
            <tbody>
              @for (
                item of listOfData
                  | paginate
                    : {
                        itemsPerPage: size,
                        currentPage: page,
                        totalItems: totalLength,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.ticketNo ? item.ticketNo : '--' }}</td>
                  <td>{{ item.uid ? item.uid : '--' }}</td>
                  <td>{{ item.vinNo ? item.vinNo : '--' }}</td>
                  <td>{{ item.imei ? item.imei : '--' }}</td>
                  <td>{{ item.rtoState ? item.rtoState : '--' }}</td>
                  <td>
                    {{
                      item.deviceType === 'ATCU2G'
                        ? 'TCU2G'
                        : item.deviceType === 'ATCU4G'
                          ? 'TCU4G'
                          : '--'
                    }}
                  </td>
                  <td>
                    {{
                      item.InstitutionalSales
                        ? 'Institutional Sales'
                        : 'TML CRM & FE'
                    }}
                  </td>
                  <td>{{ item.assignedUser ? item.assignedUser : '--' }}</td>
                  <td>
                    {{
                      item.remarkbyaccolade
                        ? simplifiedTicketStatus[item.remarkbyaccolade]
                        : '--'
                    }}
                  </td>
                  <td>
                    {{ item.posCode ? item.posCode : '--' }}
                  </td>
                  <td>
                    {{
                      item.assignDate
                        ? (item.assignDate | date: 'dd MMM yyyy | hh:mm a')
                        : '--'
                    }}
                  </td>
                  <td>
                    {{
                      item.ticketEndDate
                        ? (item.ticketEndDate | date: 'dd MMM yyyy | hh:mm a')
                        : '--'
                    }}
                  </td>
                  <td>
                    {{ getTatCategoryLabel(item.tatAnalytics?.tatCategory) }}
                    @if (item.tatAnalytics) {
                      <app-info-tooltip
                        heading="TAT Breakdown"
                        [description]="getTatBreakdownTooltip(item)"
                        (click)="$event.stopPropagation()"
                      ></app-info-tooltip>
                    }
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (totalLength === 0) {
            <tbody>
              <tr>
                <td colspan="12">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Footer Section -->
      <div class="component-footer">
        @if (totalLength !== 0) {
          <app-common-component-pagination
            [totalItems]="totalLength"
            [pageSize]="size"
            [currentPage]="page"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>

    <!-- Filter Details -->
    <div class="custom-container">
      <div class="custom-modal custom-modal-m" id="filterDetails">
        <div class="custom-modal-dialog">
          <div class="custom-modal-content">
            <!-- Modal Header -->
            <div class="custom-modal-header">
              <h4 class="custom-modal-title">
                Ticket Dashboard Details Filters
              </h4>
              <button
                type="button"
                class="custom-close-btn"
                (click)="closeModal()"
              >
                &times;
              </button>
            </div>
            <!-- Modal Body -->
            <form [formGroup]="reportsDashboardForm" novalidate>
              <div class="custom-modal-body">
                <div class="component-container">
                  <div class="component-body">
                    <div class="form-section">
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>T.Assign At: From Date</mat-label>
                          <input
                            formControlName="fromDate"
                            matInput
                            [matDatepicker]="fromDate"
                            id="fromDate"
                            placeholder="T.Assign At: From Date"
                            [max]="reportsDashboardForm.value.toDate || maxDate"
                            readonly
                          />

                          <mat-datepicker-toggle matSuffix [for]="fromDate">
                          </mat-datepicker-toggle>
                          <mat-datepicker #fromDate></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>T.Assign At: To Date</mat-label>
                          <input
                            formControlName="toDate"
                            matInput
                            [matDatepicker]="toDate"
                            id="toDate"
                            placeholder="T.Assign At: To Date"
                            [max]="maxDate"
                            [min]="reportsDashboardForm.value.fromDate || ''"
                            readonly
                          />

                          <mat-datepicker-toggle matSuffix [for]="toDate">
                          </mat-datepicker-toggle>
                          <mat-datepicker #toDate></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>T.Completed At: From Date</mat-label>
                          <input
                            formControlName="ticketCompletedAtFromDate"
                            matInput
                            [matDatepicker]="ticketCompletedAtFromDate"
                            id="ticketCompletedAtFromDate"
                            placeholder="T.Completed At: From Date"
                            [max]="
                              reportsDashboardForm.value
                                .ticketCompletedAtToDate || maxDate
                            "
                            readonly
                          />

                          <mat-datepicker-toggle
                            matSuffix
                            [for]="ticketCompletedAtFromDate"
                          >
                          </mat-datepicker-toggle>
                          <mat-datepicker
                            #ticketCompletedAtFromDate
                          ></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>T.Completed At: To Date</mat-label>
                          <input
                            formControlName="ticketCompletedAtToDate"
                            matInput
                            [matDatepicker]="ticketCompletedAtToDate"
                            id="ticketCompletedAtToDate"
                            placeholder="T.Completed At: To Date"
                            [max]="maxDate"
                            [min]="
                              reportsDashboardForm.value
                                .ticketCompletedAtFromDate || ''
                            "
                            readonly
                          />

                          <mat-datepicker-toggle
                            matSuffix
                            [for]="ticketCompletedAtToDate"
                          >
                          </mat-datepicker-toggle>
                          <mat-datepicker
                            #ticketCompletedAtToDate
                          ></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>State</mat-label>
                          <mat-select
                            #stateSelect
                            formControlName="state"
                            [formControl]="stateNameFilterCtrl"
                          >
                            @if (stateSelect.focused) {
                              <mat-option>
                                <ngx-mat-select-search
                                  [formControl]="stateNameFilterCtrl"
                                  [noEntriesFoundLabel]="'No options found'"
                                  placeholderLabel="Filter"
                                  (filteredReturn)="
                                    filteredListOfState = $event
                                  "
                                >
                                </ngx-mat-select-search>
                              </mat-option>
                            }
                            @for (item of filteredListOfState; track item) {
                              <mat-option [value]="item.value">
                                {{ item.name }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>Assigned To</mat-label>
                          <mat-select
                            #assignedUserSelect
                            formControlName="assignTo"
                            [formControl]="userNameFilterCtrl"
                          >
                            @if (assignedUserSelect.focused) {
                              <mat-option>
                                <ngx-mat-select-search
                                  [formControl]="userNameFilterCtrl"
                                  [noEntriesFoundLabel]="'No options found'"
                                  placeholderLabel="Filter"
                                  (filteredReturn)="
                                    filteredListOfAssignedUser = $event
                                  "
                                >
                                </ngx-mat-select-search>
                              </mat-option>
                            }
                            @for (
                              item of filteredListOfAssignedUser;
                              track item
                            ) {
                              <mat-option [value]="item._id">
                                {{ item.fullName }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>Ticket Status</mat-label>
                          <mat-select
                            #ticketStatusSelect
                            formControlName="ticketStatusFilter"
                            [formControl]="ticketStatusFilterCtrl"
                          >
                            @if (ticketStatusSelect.focused) {
                              <mat-option>
                                <ngx-mat-select-search
                                  [formControl]="ticketStatusFilterCtrl"
                                  [noEntriesFoundLabel]="'No options found'"
                                  placeholderLabel="Filter"
                                  (filteredReturn)="
                                    filteredListOfTicketStatus = $event
                                  "
                                >
                                </ngx-mat-select-search>
                              </mat-option>
                            }
                            @for (
                              item of filteredListOfTicketStatus;
                              track item
                            ) {
                              <mat-option [value]="item.statusCode">
                                {{ item.status }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>Dealer</mat-label>
                          <mat-select
                            #dealerSelect
                            formControlName="dealerCode"
                            [formControl]="dealerCodeFilterCtrl"
                          >
                            @if (dealerSelect.focused) {
                              <mat-option>
                                <ngx-mat-select-search
                                  [formControl]="dealerCodeFilterCtrl"
                                  [noEntriesFoundLabel]="'No options found'"
                                  placeholderLabel="Filter"
                                  (filteredReturn)="
                                    filteredListOfDealers = $event
                                  "
                                  onkeydown="return (event.keyCode!=13)"
                                >
                                </ngx-mat-select-search>
                              </mat-option>
                            }
                            @for (item of filteredListOfDealers; track item) {
                              <mat-option [value]="item.dealercode">
                                {{ item.posCode }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>Initiated By</mat-label>
                          <mat-select formControlName="initiatedBy">
                            @for (item of initiatedByList; track item) {
                              <mat-option [value]="item.initiatedByValue">
                                {{ item.initiatedByName }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>Device Type</mat-label>
                          <mat-select formControlName="deviceType">
                            @for (item of deviceTypeList; track item) {
                              <mat-option [value]="item.deviceTypeValue">
                                {{ item.deviceTypeName }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>TAT Type</mat-label>
                          <mat-select formControlName="tatType">
                            @for (item of tatTypeList; track item) {
                              <mat-option [value]="item.tatTypeValue">
                                {{ item.tatTypeName }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <!-- Separator between Body and Footer -->
                  <div class="component-separator"></div>

                  <div class="component-footer">
                    <div class="button-group">
                      <button
                        type="button"
                        class="submit-button"
                        (click)="getFilterResult()"
                      >
                        Submit
                        <mat-icon class="btn-icon">check_circle</mat-icon>
                      </button>

                      <button
                        type="button"
                        class="clear-button"
                        (click)="clear()"
                      >
                        Clear <mat-icon class="btn-icon">clear</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
